import React from 'react';

interface ScreenProps {
    name: string;
    component: React.ReactNode;
    params?: Record<string, any>;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Screen({ name, params, component }: ScreenProps) {
    return null;
}

export default Screen;
